<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px" *ngIf="SelectedPatientFormattedCode">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='SelectedPatientFormattedCode.PatientImageFile' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.DisplayName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Gender}}/{{SelectedPatientFormattedCode.Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.FormattedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnfeatures2">
    <div class="card">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px">
        <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
          <div class="col-md-3">
            <label class="margin-bottom-0px margin-left-5px">Admission Details </label>
          </div>
          <!--<div class="col-md-3">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
          </div>-->

          <div class="col-md-2">
            <div class="row">
              <!--<div class="col-md-6 padding-right-0px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>-->
              <div class="col-md-12 padding-left-0px">
                <!--<button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>-->
                <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="Cancel()">Cancel </button>

                <button type="submit" (click)="onSubmit()" class="btn actions-btn-prime font-size-13px float-right margin-right-5px">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
              </div>
            </div>
            <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



          </div>

        </div>
      </div>
      <div class="card-body  padding-bottom-0px padding-right-0px padding-top-10px">
        <div class="row">
          <div class="col-md-1">

          </div>
          <div class="col-md-11">
            <div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                      <div class="row">
                        <div class="col-md-4">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Admission Details
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission No</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="Admission No"
                                       id="CurrentSaveAdmissionDetailsRequest.AdmissionCode"
                                       [(ngModel)]="CurrentSaveAdmissionDetailsRequest.AdmissionCode"
                                       name="CurrentSaveAdmissionDetailsRequest.AdmissionCode" pattern="^[\sa-zA-Z,._\-?]*$"
                                       maxlength="30" minlength="1" #AdmissionCode="ngModel">

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Date</label>
                              </div>


                              <div class="col-md-3">
                                <div class="date-form">
                                  <!--<input class="form-control" placeholder="Admission Date" ngbDatepicker #d1="ngbDatepicker">

                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>-->

                                  <input type="text" class="form-control form-control-patient" placeholder="Admission Date"
                                         name="dp" [(ngModel)]="AdmissionDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #d="ngbDatepicker" #DOBin="ngModel">

                                  <a (click)="d.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Type</label>
                              </div>


                              <div class="col-md-3">

                                <!--<CodeTypeValue CodeType="ADMTY"></CodeTypeValue>-->
                                <CodeTypeValue CodeType="ADMTY"
                                               id="CurrentSaveAdmissionDetailsRequest.AdmissionType"
                                               [(ngModel)]="CurrentSaveAdmissionDetailsRequest.AdmissionType" SelectedValue="CurrentSaveAdmissionDetailsRequest.AdmissionType"
                                               name="CurrentSaveAdmissionDetailsRequest.AdmissionType">
                                </CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Case Type</label>
                              </div>


                              <div class="col-md-3">

                                <!--<CodeTypeValue CodeType="CSTYP"></CodeTypeValue>-->
                                <CodeTypeValue CodeType="CSTYP"
                                               id="CurrentSaveAdmissionDetailsRequest.CaseType"
                                               [(ngModel)]="CurrentSaveAdmissionDetailsRequest.CaseType" SelectedValue="CurrentSaveAdmissionDetailsRequest.CaseType"
                                               name="CurrentSaveAdmissionDetailsRequest.CaseType">
                                </CodeTypeValue>
                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Category</label>
                              </div>


                              <div class="col-md-3">

                                <!--<CodeTypeValue CodeType="TRCAT"></CodeTypeValue>-->
                                <CodeTypeValue CodeType="TRCAT"
                                               id="CurrentSaveAdmissionDetailsRequest.TreatmentCategory"
                                               [(ngModel)]="CurrentSaveAdmissionDetailsRequest.TreatmentCategory" SelectedValue="CurrentSaveAdmissionDetailsRequest.TreatmentCategory"
                                               name="CurrentSaveAdmissionDetailsRequest.TreatmentCategory">
                                </CodeTypeValue>
                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Provider Incharge</label>
                              </div>


                              <div class="col-md-3">
                                <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorn">{{PrimaryDoctor}}</label>
                                <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorO">{{PrimaryDoctor}}</label>
                              </div>
                              <div class="col-md-1">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPrimaryDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                              </div>

                            </div>


                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample3">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                      <div class="row">
                        <div class="col-md-4">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                              Payment Details
                            </button>
                          </h5>
                        </div>
                      </div>


                    </div>

                    <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">IP Advance</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="IP Advance"
                                       pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />

                              </div>
                            </div>


                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample4">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                      <div class="row">
                        <div class="col-md-4">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                              Admit Location
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Care Unit</label>
                              </div>


                              <div class="col-md-3">

                                <!--<CustomDataByRequestType RequestedType="CareUnits" FacilityCode={{FacilityCode}} (keyChange)="onAssignedToActorCode2($event)"
                                                         id="CurrentSaveAdmissionDetailsRequest.CareUnitCode" SelectedValue=""
                                                         [(ngModel)]="CurrentSaveAdmissionDetailsRequest.CareUnitCode"
                                                         name="CurrentSaveAdmissionDetailsRequest.CareUnitCode" required #MedicineName="ngModel">
                                </CustomDataByRequestType>-->
                                <CustomDataByRequestType RequestedType="CareUnits" FacilityCode={{FacilityCode}}
                                                         (keyChange)="Roleassign($event)"
                                                         [(ngModel)]="SelectedCareUnitCode" name="SelectedCareUnitCode" SelectedValue="SelectedCareUnitCode"
                                                         required>
                                </CustomDataByRequestType>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Bed Location</label>
                              </div>


                              <div class="col-md-3">

                                <CustomDataByRequestType RequestedType="BedLocations" FacilityCode={{FacilityCode}}
                                                         (keyChange)="Roleassign($event)" CustomCode={{SelectedCareUnitCode}} ShouldLoadByParent="true"
                                                         [(ngModel)]="CurrentSaveAdmissionDetailsRequest.BedLocation" name="CurrentSaveAdmissionDetailsRequest.BedLocation" SelectedValue=""
                                                         required>
                                </CustomDataByRequestType>
                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Planned Discharged On</label>
                              </div>


                              <div class="col-md-3">

                                <div class="date-form">

                                  <input type="text" class="form-control form-control-patient" placeholder="Planned Discharged On"
                                         name="dp1" [(ngModel)]="PlannedDischargeDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #d1="ngbDatepicker" #DOBin="ngModel">

                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>
                                </div>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Estimated Stay In Days</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="Estimated Stay"
                                       id="CurrentSaveAdmissionDetailsRequest.EstimatedStay"
                                       [(ngModel)]="CurrentSaveAdmissionDetailsRequest.EstimatedStay"
                                       name="CurrentSaveAdmissionDetailsRequest.EstimatedStay" pattern="^[\sa-zA-Z,._\-?]*$"
                                       maxlength="30" minlength="1" #CareUnit="ngModel">
                              </div>

                            </div>


                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!--<div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample5">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                      <div class="row">
                        <div class="col-md-7">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                              Patient Consent
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Signed</label>
                              </div>


                              <div class="col-md-3">

                                <input type="checkbox" class="checkbox2">

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Consent Form No</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="Consent Form No"
                                       pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />

                              </div>

                            </div>


                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample6">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                      <div class="row">
                        <div class="col-md-7">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                              Admission Status
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Status</label>
                              </div>


                              <div class="col-md-3">

                                <CodeTypeValue CodeType="ADMST"></CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Admission Reason</label>
                              </div>


                              <div class="col-md-3">

                                <CodeTypeValue CodeType="ADMRS"></CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment</label>
                              </div>


                              <div class="col-md-3">
                                <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorn">{{PrimaryDoctor}}</label>
                                <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorO">{{PrimaryDoctor}}</label>
                              </div>
                              <div class="col-md-1">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPrimaryDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                              </div>

                            </div>

                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Proposed Treatment Remarks</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="Proposed Treatment Remarks"
                                       pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Procedure Done On</label>
                              </div>


                              <div class="col-md-3">

                                <div class="date-form">
                                  <input class="form-control" placeholder="Procedure Done On" ngbDatepicker #d3="ngbDatepicker">

                                  <a (click)="d3.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>
                                </div>

                              </div>

                            </div>


                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div>
              <form class="form " novalidate="" #f="ngForm">
                <div class="accordion" id="accordionExample7">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne7">
                      <div class="row">
                        <div class="col-md-1">
                          <h5 class="mb-0 height-24px">
                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
                              Insurance
                            </button>
                          </h5>
                        </div>
                        <div class="col-md-1">
                          <input type="checkbox" class="checkbox2" (click)="toggle()">

                        </div>
                      </div>


                    </div>

                    <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7" *ngIf="Insurancetoggle">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Debtor Type</label>
                              </div>


                              <div class="col-md-3">

                                <CodeTypeValue CodeType="DBRTY"></CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Insurance Provider</label>
                              </div>


                              <div class="col-md-3">

                                <CodeTypeValue CodeType="INLST"></CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Card No</label>
                              </div>


                              <div class="col-md-3">

                                <input type="text" class="form-control" placeholder="Card No"
                                       pattern="^[\sa-zA-Z0-9,._''\-?]*$" maxlength="100" />

                              </div>

                            </div>


                          </div>
                        </div>

                        <div class="row my-profile-form">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                            <div class="row">
                              <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Approval Status</label>
                              </div>


                              <div class="col-md-3">

                                <CodeTypeValue CodeType="APSTA"></CodeTypeValue>

                              </div>

                            </div>


                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>-->
          </div>
        </div>


      </div>


    </div>
  </div>


</div>
